import { createAction } from "@reduxjs/toolkit"
import { NAMESPACE } from "../constants"

export const resetUserSchedulesAction = createAction(
  `${NAMESPACE}/resetUserSchedules`
)
